import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { exemptionType3DS, ICardTransaction } from '@/features/cards/store/models/card.model';
import { PaymentTruncateCell } from '@/features/cards/components/CardTransactionsTable/PaymentTruncateCell';
import {
  getCardTransactionConfigKey,
  TCardTransactionColumnSetting,
} from '@/features/cards/store/models/card-transactions.model';

interface IPayment3DSCellProps {
  transaction: ICardTransaction;
  config?: TCardTransactionColumnSetting;
}

export function Payment3DSCell({ transaction, config }: IPayment3DSCellProps) {
  const { t } = useTranslation();

  const get3DSExemptionLabel = useCallback(() => {
    const exemption = transaction?.['3dsExemptionType'];
    if (!exemption) return;

    if (exemptionType3DS.includes(exemption)) {
      return [
        exemption,
        t(`pages.currentProfiles.cards.transactions.table.headers.3dsExemptionTypes.${exemption}`),
      ].join(': ');
    }
    return exemption;
  }, [t, transaction]);

  return (
    <div className="flex flex-col gap-1 min-w-[100px]">
      {getCardTransactionConfigKey(config, 'is3DS') && (
        <span className="typo-body-regular-paragraph text-secondary">
          {transaction?.is3DS ? t('components.molecules.forms.yes') : t('components.molecules.forms.no')}
        </span>
      )}
      {getCardTransactionConfigKey(config, '3dsExemptionType') && get3DSExemptionLabel() && (
        <PaymentTruncateCell className="typo-body-regular-small text-tertiary" textString={get3DSExemptionLabel()} />
      )}
    </div>
  );
}
